import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default function setCarousel() {
  const productsCarousel = document.querySelectorAll('[data-products-carousel]');

  productsCarousel.forEach((section) => {
    const carousel = section.querySelector('.swiper');
    const pagination = section.querySelector('.swiper-pagination');
    const next = section.querySelector('.swiper-button-next');
    const prev = section.querySelector('.swiper-button-prev');

    if (carousel) {
      const swiper = new Swiper(carousel, {
        modules: [Navigation, Pagination],
        slidesPerView: 1.3,
        spaceBetween: 8,
        watchOverflow: true,
        speed: 1000,
        loop: true,
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 24,
            centeredSlides: true,
            navigation: {
              nextEl: next,
              prevEl: prev,
            },
          },
          1440: {
            slidesPerView: 6,
            spaceBetween: 12,
            centeredSlides: true,
            navigation: {
              nextEl: next,
              prevEl: prev,
            },
          },
        },
        pagination: {
          el: pagination,
          type: 'bullets',
          clickable: true,
        },
      });
    }
  });
}
